import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { WEBSITE_ANALYSIS_WIDGET_NAMES } from "app/pages/sales-intelligence/pages/company-analysis/constants";
import { EAdsTabs } from "app/components/React/PlaResearch/type";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import CountryService from "app/services/CountryService";
import durationService, { BasicDurations } from "app/services/DurationService";

import type { SelectorHandlers } from "app/components/filters-bar/useSelectorTrigger";

export const getKeywordsCtaLinkForSI = (widgetName: string) => (params) => {
    return {
        href: proNavigator.href("accountreview_website_search_keyword", params),
        target: "_self",
        onClick: () => {
            companyAnalysisTrackingService.website.trackWidgetCtaClick(widgetName, params.key);
        },
    };
};

export const getKeywordsCtaLinkForDS = (params) => {
    return {
        href: proNavigator.href("organicsearch_websites_v2_traffic_keywords", params),
        target: "_self",
    };
};

export const getAdsCtaLinkForSI = (params) => {
    return {
        href: proNavigator.href("accountreview_website_search_ads", params),
        target: "_self",
        onClick: () => {
            companyAnalysisTrackingService.website.trackWidgetCtaClick(
                WEBSITE_ANALYSIS_WIDGET_NAMES.paidSearchAds,
                params.key,
            );
        },
    };
};

export const getAdsCtaLinkForDS = (params) => {
    return {
        href: proNavigator.href("paidsearch_website_ads", {
            ...params,
            selectedPageTab: EAdsTabs[EAdsTabs.Text],
        }),
        target: "_self",
    };
};

export const getBrandedNonBrandedCtaLinkForSI = (params) => {
    return {
        href: proNavigator.href("accountreview_website_search_overview", params),
        target: "_self",
        onClick: () => {
            companyAnalysisTrackingService.website.trackWidgetCtaClick(
                WEBSITE_ANALYSIS_WIDGET_NAMES.trafficBranded,
                params.key,
            );
        },
    };
};

export const getBrandedNonBrandedCtaLinkForDS = (params) => {
    return {
        href: proNavigator.href("digitalsuite_website_search_overview", params),
        target: "_self",
    };
};

/**
 * These widgets always request the latest complete month, ignoring the page-level date range,
 * so the subtitle must print that fixed month rather than the user's selection.
 */
export const generateLastMonthSubtitleFilters = (
    country: string,
    webSource: string,
    handlers: SelectorHandlers = {},
) => {
    const { forAPI } = durationService.getDurationData(BasicDurations.LAST_MONTH);
    return [
        {
            filter: "date",
            value: {
                to: forAPI.to,
                format: "MMMM YYYY",
            },
            onClick: handlers.onDateClick,
            onMouseEnter: handlers.onDateHover,
        },
        {
            filter: "country",
            countryCode: country,
            value: CountryService.getCountryById(country)?.text,
            onClick: handlers.onCountryClick,
            onMouseEnter: handlers.onCountryHover,
        },
        {
            filter: "webSource",
            value: webSource,
            onMouseEnter: handlers.onWebSourceHover,
        },
    ];
};
